import { Skeleton } from "antd";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-dashed.svg";

const Loading = () => {
  return (
    <div className="relative !rounded-xl mx-5 py-5">
      <Skeleton.Button block className="!h-[480px] z-0" />

      <div className="absolute top-5 flex flex-col p-3 gap-3 items-center justify-center w-full">
        <Skeleton.Avatar active size="large" />
        <Skeleton.Button className="!h-3 !w-20" active size="small" />
        <Skeleton.Button className="!h-3 !w-28" active size="small" />
        <Skeleton.Button className="!h-3 !w-20" active size="small" />
        <div className="mt-5 border-t border-b border-gray--4 py-5 w-full">
          <div className="text-center !h-8 mb-3">
            <Skeleton.Button className="!h-8 !w-[200px]" active size="small" />
          </div>
          <div className="table m-auto mb-3">
            <ArrowDown className="w-6" />
          </div>
          <div className="text-center !h-8 ">
            <Skeleton.Button className="!h-8 !w-[200px]" active size="small" />
          </div>
        </div>
        <div className="flex justify-between w-full">
          <Skeleton.Button className="!h-3 !w-12" active size="small" />
          <Skeleton.Button className="!h-3 !w-16" active size="small" />
        </div>
        <div className="flex justify-between w-full">
          <Skeleton.Button className="!h-3 !w-12" active size="small" />
          <Skeleton.Button className="!h-3 !w-16" active size="small" />
        </div>
        <div className="flex justify-between w-full">
          <Skeleton.Button className="!h-3 !w-12" active size="small" />
          <Skeleton.Button className="!h-3 !w-16" active size="small" />
        </div>
        <div className="text-center border-t border-gray--4 py-5 w-full">
          <Skeleton.Button className="!h-10 !w-[200px]" active size="small" />
        </div>
      </div>
    </div>
  );
};

export default Loading;
